import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';

export interface PayeesProjectionMonth {
  year: number;
  month: number;
  actualExpenses: number;
  pendingPayables: number;
  paidPayables: number;
  recurringProjected: number;
  totalProjected: number;
}

export interface PayeesProjectionResponse {
  months: PayeesProjectionMonth[];
}

export const usePayeesProjection = (year?: number) => {
  const y = year ?? new Date().getFullYear();
  const { data, error, isLoading, mutate } = useSWR<PayeesProjectionResponse>(
    `/payables/expense-projection?year=${y}`,
    fetcher,
    { revalidateOnFocus: true }
  );
  return {
    data: data?.months ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
};
